import { createRoute, lazyRouteComponent } from "@tanstack/react-router";
import { Route as rootRoute } from "./__root";

// Landing + filtro de entrada de un programa digital autoservicio (ej. "Muscle Up") — página
// pública pero NO enlazada desde ningún menú (ver SiteNav.tsx): solo se llega con el link
// directo. El contenido completo (competencias, filtro, etc.) vive en Firestore
// (digitalPrograms/{slug}), no en el código — ver src/lib/digital-programs.ts.
export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: "/programas/$slug",
  // noindex: son programas ocultos a propósito, no deben aparecer en buscadores.
  head: () => ({ meta: [{ name: "robots", content: "noindex, nofollow" }] }),
  component: lazyRouteComponent(() => import("./programa-digital-landing"), "ProgramaDigitalLandingPage"),
});
